import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popup, Flex, Loader, Link } from 'nallian-shared-ui/lib/components';
import { NoBreakSpan } from '../../app/styles';
import identityPrincipalsService from '../services/identityPrincipalsService';

const ScrollableContent = styled.div`
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
`;

const PrincipalItem = styled.div`
  padding: 0.5rem;
`;

const PopupTitle = styled.div`
  font-weight: bold;
  padding: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
`;

const PrincipalCountPopup = ({
  value,
  item,
  dispatchIdentityPrincipalsGet,
  identityPrincipalsFetch,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      dispatchIdentityPrincipalsGet(item?.id);
    }
  }, [isOpen, dispatchIdentityPrincipalsGet, item?.id]);

  if (!value || value === 0) {
    return <i>{t('noPrincipals')}</i>;
  }

  const principals = identityPrincipalsFetch?.value;

  return (
    <Popup
      content={
        <ScrollableContent>
          {identityPrincipalsFetch.pending && (
            <Flex direction="column" padding="1rem">
              <Loader active inline="centered" size="small" />
            </Flex>
          )}
          {identityPrincipalsFetch.rejected && (
            <Flex direction="column" padding="1rem">
              <span>{t('errorLoadingPrincipals')}</span>
            </Flex>
          )}
          {identityPrincipalsFetch.fulfilled && (
            <>
              {!principals || principals.length === 0 ? (
                <Flex direction="column" padding="1rem">
                  <i>{t('noPrincipals')}</i>
                </Flex>
              ) : (
                <>
                  <PopupTitle>{t('linkedPrincipals')}</PopupTitle>
                  <Flex direction="column">
                    {principals.map(principal => (
                      <PrincipalItem key={principal.id}>
                        <Link to={`/principals/${principal.id}`} target="_blank">
                          {principal.fullName || t('unnamed')}
                        </Link>
                      </PrincipalItem>
                    ))}
                  </Flex>
                </>
              )}
            </>
          )}
        </ScrollableContent>
      }
      on="hover"
      hoverable
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      trigger={<NoBreakSpan>{t('principalCount', { count: value })}</NoBreakSpan>}
    />
  );
};

PrincipalCountPopup.propTypes = {
  value: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  dispatchIdentityPrincipalsGet: PropTypes.func.isRequired,
  identityPrincipalsFetch: PropTypes.object.isRequired,
};

export default identityPrincipalsService(PrincipalCountPopup);
